import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

import { Logo } from '@/components/brand/Logo'

/** Minimal chrome for Clerk auth pages (no app tab bar). */
export function AuthLayout({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) {
  return (
    <div className="bg-surface relative flex min-h-screen flex-col">
      <div
        aria-hidden="true"
        className="bg-hero-glow pointer-events-none absolute inset-x-0 top-0 h-[420px] blur-3xl"
      />

      <header className="px-margin-mobile md:px-margin-desktop max-w-site relative z-10 mx-auto flex w-full items-center justify-between py-6">
        <Link to="/" aria-label="dizcant home">
          <Logo />
        </Link>
      </header>

      <main
        id="main"
        className="relative z-10 mx-auto flex w-full max-w-md flex-grow flex-col justify-center px-4 pb-16"
      >
        <h1 className="font-display text-headline-lg-mobile text-fg md:text-headline-lg mb-6 text-center">
          {title}
        </h1>
        {children}
      </main>
    </div>
  )
}
